import { Phone, MapPin, Mail } from 'lucide-react';

export function TopBar() {
  return (
    <div style={{ backgroundColor: '#08122B' }} className="text-foreground">
      <div className="container-custom lg:pl-20 xl:pl-25 py-0.5 lg:py-1">
        <div className="flex flex-col sm:grid sm:grid-cols-2 lg:flex lg:flex-row items-stretch lg:items-center gap-2 lg:gap-12 w-full lg:w-auto lg:justify-end">

          {/* Location (hidden on small screens like before) */}
          <a href="https://maps.app.goo.gl/ayxADVJQgyUUaLC37" target="_blank" rel="noopener noreferrer" className="hidden lg:flex items-center gap-2 hover:opacity-80 transition-opacity">
            <div
              className="flex items-center justify-center"
              style={{
                width: 20,
                height: 20,
                borderRadius: 4,
                border: '1.5px solid rgba(212,175,55,0.95)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
              aria-hidden
            >
              <MapPin stroke="#D4AF37" strokeWidth={2} size={10} />
            </div>
            <div className="leading-none">
              <p style={{ fontSize: '9px', fontWeight: 400, letterSpacing: '2px', color: '#7A9BAD', textTransform: 'uppercase', fontFamily: 'Georgia, serif' }}>Location</p>
              <p className="text-[10px] font-medium tracking-wide" style={{ color: '#E8EDF0' }}>Thirunelvely, Jaffna</p>
            </div>
          </a>

          {/* Email */}
          <a href="mailto:astconst.14@gmail.com" className="flex items-center gap-1.5 lg:gap-2 min-w-0 rounded-lg border border-[#D4AF37]/30 px-2 py-1 lg:border-0 lg:px-0 lg:py-0">
            <div
              className="flex items-center justify-center"
              style={{
                width: 20,
                height: 20,
                borderRadius: 4,
                border: '1.5px solid rgba(212,175,55,0.95)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
              aria-hidden
            >
              <Mail stroke="#D4AF37" strokeWidth={2} size={10} />
            </div>
            <div className="leading-tight min-w-0">
              <p style={{ fontSize: '9px', fontWeight: 400, letterSpacing: '2px', color: '#7A9BAD', textTransform: 'uppercase', fontFamily: 'Georgia, serif', whiteSpace: 'nowrap' }}>Email</p>
              <p className="text-[10px] font-medium tracking-wide truncate" style={{ color: '#E8EDF0' }}>astconst.14@gmail.com</p>
            </div>
          </a>

          {/* Mobile / WhatsApp */}
          <a href="tel:0750441260" className="flex items-center gap-1.5 lg:gap-2 min-w-0 rounded-lg border border-[#D4AF37]/30 px-2 py-1 lg:border-0 lg:px-0 lg:py-0">
            <div
              className="flex items-center justify-center"
              style={{
                width: 20,
                height: 20,
                borderRadius: 4,
                border: '1.5px solid rgba(212,175,55,0.95)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
              aria-hidden
            >
              <Phone stroke="#D4AF37" strokeWidth={2} size={10} />
            </div>
            <div className="leading-tight min-w-0">
              <p style={{ fontSize: '9px', fontWeight: 400, letterSpacing: '2px', color: '#7A9BAD', textTransform: 'uppercase', fontFamily: 'Georgia, serif', whiteSpace: 'nowrap' }}>Call · WhatsApp</p>
              <p className="text-[10px] font-medium tracking-wide whitespace-nowrap" style={{ color: '#E8EDF0' }}>0750 441 260</p>
            </div>
          </a>

          {/* Landline */}
          <a href="tel:0212228130" className="flex items-center gap-1.5 lg:gap-2 min-w-0 rounded-lg border border-[#D4AF37]/30 px-2 py-1 lg:border-0 lg:px-0 lg:py-0">
            <div
              className="flex items-center justify-center"
              style={{
                width: 20,
                height: 20,
                borderRadius: 4,
                border: '1.5px solid rgba(212,175,55,0.95)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
              aria-hidden
            >
              <Phone stroke="#D4AF37" strokeWidth={2} size={10} />
            </div>
            <div className="leading-tight min-w-0">
              <p style={{ fontSize: '9px', fontWeight: 400, letterSpacing: '2px', color: '#7A9BAD', textTransform: 'uppercase', fontFamily: 'Georgia, serif', whiteSpace: 'nowrap' }}>Landline</p>
              <p className="text-[10px] font-medium tracking-wide whitespace-nowrap" style={{ color: '#E8EDF0' }}>021 222 8130</p>
            </div>
          </a>

        </div>
      </div>
    </div>
  );
}
